// Correctly count multibyte emoji length
const EMOJI_CODE_POINT = /\p{Extended_Pictographic}|\p{Regional_Indicator}/u

export const isSingleEmoji = (text: string): boolean => {
    if (typeof Intl === 'undefined' || typeof Intl.Segmenter !== 'function') {
        return false
    }

    const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    const segments = Array.from(segmenter.segment(text))

    return segments.length === 1 && EMOJI_CODE_POINT.test(segments[0].segment)
}
